import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const WatchlistIconSvg = (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M28 16H16v1h12v-1ZM28 20H16v1h12v-1ZM16 24h12v1H16v-1Z"/>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m22 30-10 4V12a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v22l-10-4Zm-9 2.52V12h18v20.52l-9-3.6-9 3.6Z"
        />
    </svg>
)
const Watchlist: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{fontSize: '40px'}}>
        {WatchlistIconSvg}
    </SvgIcon>
)
export default Watchlist
